export { default } from "ember-stereo/helpers/sound-error-details";
